
class TransCloud {
  constructor(parentCont, data) {
    // const
    this.Z_MAX = 500;

    // vars
    this.parentCont = parentCont;
    this.data = data;
    this.cloudId = this.data.id.split('_')[0].replace('c', '');
    this.position = {
      z: this.Z_MAX * (this.data.id.split('_')[1] / 100),
      base: {
        x: this.data.iX,
        y: this.data.iY,
      },
    };

    // parts
    this.sprite = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    this.sprite = new PIXI.Sprite.fromFrame(`cloud-${this.cloudId}.png`);
    this.parentCont.addChild(this.sprite);
    this.sprite.anchor.x = 0.5;
    this.sprite.anchor.y = 0.5;
    this.sprite.scale.x = this.data.sX;
    this.sprite.scale.y = this.data.sY;
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    this.sprite.x = this.position.base.x;
    this.sprite.y = this.position.base.y + (this.position.z * aScene.sceneManager.offsetProgress);
  }
}

export default TransCloud;



// WEBPACK FOOTER //
// ./src/js/scene/parts/transition/parts/TransCloud.js